/**
 * 创作者中心- 删除会话
 * @returns
 */
import { useAppDispatch } from "@/store/hooks";
import { Content } from "@/types/content";
import {
  Flex,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
} from "@chakra-ui/react";


type Props = {
  isOpen: boolean;
  onClose: () => void;
  delWorks: Content;
};

const DelAiWorksModal = (props: Props) => {
  const { isOpen, onClose, delWorks } = props;
  const dispatch = useAppDispatch();

  const handleDelAiWorks = () => {
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent w="420px" bg="#fff">
          <ModalHeader color="#27314D" fontSize={"18px"}>
            你确定要删除此创作吗？
          </ModalHeader>
          <ModalCloseButton color={"#B9B9B9"} />
          <ModalBody pb={6}>
            <Box fontSize={"14px"} color="#27314D">
            删除此创作后，所有文件将立即被永久删除，此操作不可撤销，请确认！
            </Box>
            <Flex mt="40px" justifyContent={"flex-end"}>
              <Button
                w="76px"
                h="37px"
                mr="15px"
                bg="#CBD1DF"
                color={"#27314D"}
                fontSize="12px"
                fontWeight={"normal"}
                borderRadius={0}
                _hover={{
                  bg: "#CBD1DF",
                  color: "#8E94A9",
                }}
                onClick={() => onClose()}
              >
                取消
              </Button>
              <Button
                w="76px"
                h="37px"
                bg="#496AE1"
                color={"#FFFFFF"}
                fontSize="12px"
                fontWeight={"normal"}
                borderRadius={0}
                _hover={{
                  bg: "#3F5BC1",
                  color: "#E6E6E6",
                }}
                onClick={handleDelAiWorks}
              >
                完成
              </Button>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
  );
};

export default DelAiWorksModal;